<template>
    <div>
        <ul v-loading="loading" >
                <li v-for="row in data">
                    <span v-if="row.title && row.title!=='unspecified by data source'">
                        <a :href="row.address_normalized"  target="_blank">{{ row.title}}</a>
                    </span>
                    <span v-else-if="row.file_name">
                        <a :href="row.address_normalized"  target="_blank">{{ row.file_name }}</a>
                    </span>
                    <span v-else>
                        <a :href="row.address_normalized"  target="_blank">{{row.address_normalized}}</a>
                    </span>
                    <span style="text-decoration: underline;" @click="go_details(row)">details</span>
                    <span v-if="row.example_dupe">
                        <br />
                        probable dupe: <a :href="row.example_dupe"  target="_blank">{{row.example_dupe}}</a>
                        <span v-if="row.count_dupes>1"><br />(one example out of {{row.count_dupes}} found)</span>
                        with {{row.dupe_confidence}} confidence
                    </span>

                </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ['data','extent_id'],
        computed: {
            loading: function () {
                return (this.data == null)
            }
        },
        methods: {
            go_details(row) {
                let asset_id = row.processed_asset_id
                let sample_extent_id = this.extent_id
                if (row.hasOwnProperty('extent_id')) {
                  sample_extent_id = row.extent_id
                }
                window.open("/assetdetails/" + sample_extent_id + "/" + asset_id,'_blank')
            }
        }
    }
    // props in: array of objects, each with at least a name and URL
</script>